export class DuplicateActionOptions {
  static asRadioOptions() {
    return [
      { id: 'backup', label: 'Guardar archivo existente como respaldo', value: 'backup' },
      { id: 'replace', label: 'Reemplazar archivo existente', value: 'replace' },
    ];
  }
}
